import { ColumnHelper } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";

import { MatchesTableEntry } from "../../../../hooks/use_resource_matches";
import { AvailabilityCell } from "./availability_cell";

type CreateAvailabilityColumnArgs = {
  headerLabel: string;
};

export const createAvailabilityColumn = (
  columnHelper: ColumnHelper<MatchesTableEntry>,
  { headerLabel }: CreateAvailabilityColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "availability",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <AvailabilityCell value={info.getValue().availabilityScore} />,
    enableSorting: false,
    size: 40
  });
